import { PROMOTION_NEW_CHANNEL, PROMOTION_PAID_OUT } from '@bg-shared/constants/socketChannels';
import { API_URLS } from '@bg-shared/constants/apiUrls';
import HttpClientRepository from '@bg-shared/infrastructure/HttpClient/HttpClient.repository';
import WebSocketsRepository from '@bg-shared/infrastructure/WebSockets/WebSockets.repository';
import { IPromotion, IPromotionPayout, IPromotionsState } from './interfaces';

export default class PromotionsApi {
    constructor(
        private readonly httpClient: HttpClientRepository,
        private readonly webSockets: WebSocketsRepository,
    ) {}

    subscribePromotions(callback: ICallback<IPromotion>): void {
        this.webSockets.on<IPromotion>(PROMOTION_NEW_CHANNEL, callback);
    }

    subscribePromotionsPayout(callback: ICallback<IPromotionPayout>): void {
        this.webSockets.on<IPromotionPayout>(PROMOTION_PAID_OUT, callback);
    }

    fetchPromotion(partnerCode: string): Promise<IPromotionsState> {
        return this.httpClient.get<IPromotionsState>(`${API_URLS.PROMOTION}/${partnerCode}`);
    }
}
